import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { api } from '@/lib/api';

export default function AdminOffers() {
    const [offers, setOffers] = useState([]);
    useEffect(() => { api.get('/admin/offers').then(({ data }) => setOffers(data)); }, []);

    return (
        <AdminLayout>
            <div className="p-10" data-testid="admin-offers-page">
                <div className="overline">Offers</div>
                <h1 className="font-serif text-4xl text-navy mt-2 mb-8">Offers & Coupons</h1>
                <div className="grid md:grid-cols-2 gap-4">
                    {offers.map((o) => (
                        <div key={o.id} className="bg-white border border-border-subtle p-6 flex gap-4">
                            <img src={o.image_url} alt="" className="w-24 h-24 object-cover shrink-0" />
                            <div className="flex-1">
                                <div className="overline text-gold mb-1">{o.brand_name}</div>
                                <div className="font-serif text-lg text-navy">{o.title}</div>
                                <div className="text-xs text-text-tertiary mt-2 line-clamp-2">{o.description}</div>
                                <div className="mt-2 flex flex-wrap gap-3 text-xs">
                                    <span className="text-text-tertiary">Type: <span className="text-navy">{o.offer_type}</span></span>
                                    <span className="text-text-tertiary">Code: <span className="text-navy font-mono">{o.coupon_code || '—'}</span></span>
                                    <span className="text-text-tertiary">Views: <span className="text-navy">{o.view_count}</span></span>
                                    <span className={`text-xs uppercase tracking-widest ${o.is_active ? 'text-emerald-700' : 'text-rose-700'}`}>{o.is_active ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </AdminLayout>
    );
}
